import { json } from "@sveltejs/kit";
import { t as taskManager } from "../../../../../chunks/task-manager.js";
const POST = async ({ request }) => {
  try {
    const { taskId, command } = await request.json();
    if (!taskId || !command) {
      return json({ error: "Task ID and command are required" }, { status: 400 });
    }
    const pid = taskManager.runTask(taskId, command);
    return json({ success: true, pid });
  } catch (error) {
    console.error("Failed to run task:", error);
    return json({ error: error.message }, { status: 500 });
  }
};
export {
  POST
};
